import { useState } from "react";
import { Stack, TextField, Button, Typography, IconButton, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

export default function ConfigEtapas({ store }) {
  const [nombre, setNombre] = useState("");
  const [ocultar, setOcultar] = useState(null);
  const [destino, setDestino] = useState("");
  const etapas = store.config.etapasCatalogo;
  const guardar = (id, cambios, destinos) => store.guardarEtapas(etapas.map(e => e.id === id ? { ...e, ...cambios } : e), destinos);
  const agregar = (texto) => {
    const limpio = texto.trim();
    if (!limpio || etapas.some(e => e.nombre.toLocaleLowerCase() === limpio.toLocaleLowerCase())) return;
    const nuevas = [...etapas];
    const index = nuevas.findIndex(e => e.id === "inscrito");
    const id = window.crypto?.randomUUID?.() || `etapa-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
    nuevas.splice(index < 0 ? nuevas.length : index, 0, { id, nombre: limpio, activa: true });
    store.guardarEtapas(nuevas);
    setNombre("");
  };
  const mover = (index, paso) => {
    const nuevas = [...etapas];
    [nuevas[index], nuevas[index + paso]] = [nuevas[index + paso], nuevas[index]];
    store.guardarEtapas(nuevas);
  };
  return <Stack spacing={1.5}>
    <Typography variant="caption" color="text.secondary">Al ocultar una etapa, también desaparece de los gráficos y análisis por etapa. Su historial se conserva y vuelve a mostrarse al restaurarla.</Typography>
    {etapas.map((e, index) => <Stack key={e.id} direction="row" spacing={0.5} alignItems="center">
      <TextField key={`${e.id}-${e.nombre}`} label="Etapa" size="small" defaultValue={e.nombre} fullWidth
        onBlur={event => { const value = event.target.value.trim(); if (value) guardar(e.id, { nombre: value }); else event.target.value = e.nombre; }} />
      <IconButton aria-label={`Subir ${e.nombre}`} size="small" disabled={index === 0} onClick={() => mover(index, -1)}><ArrowUpwardIcon fontSize="small" /></IconButton>
      <IconButton aria-label={`Bajar ${e.nombre}`} size="small" disabled={index === etapas.length - 1} onClick={() => mover(index, 1)}><ArrowDownwardIcon fontSize="small" /></IconButton>
      <Button size="small" disabled={e.activa && store.config.etapasPipeline.length === 1} onClick={() => {
        if (e.activa && store.leads.some(l => l.etapa === e.id)) { setOcultar(e); setDestino(""); }
        else guardar(e.id, { activa: !e.activa });
      }}>{e.activa ? "Ocultar" : "Restaurar"}</Button>
    </Stack>)}
    <Stack direction="row" spacing={1}>
      <TextField label="Nueva etapa" size="small" value={nombre} onChange={e => setNombre(e.target.value)} fullWidth />
      <Button disabled={!nombre.trim() || etapas.some(e => e.nombre.toLocaleLowerCase() === nombre.trim().toLocaleLowerCase())} onClick={() => agregar(nombre)}>Agregar</Button>
    </Stack>
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="caption">Sugerencias:</Typography>
      {["Reuniones", "Propuestas"].filter(n => !etapas.some(e => e.nombre.toLowerCase() === n.toLowerCase() || (n === "Propuestas" && e.id === "propuesta_enviada" && e.activa))).map(n => <Button key={n} size="small" onClick={() => agregar(n)}>{n}</Button>)}
    </Stack>
    <Dialog open={!!ocultar} onClose={() => setOcultar(null)} fullWidth maxWidth="xs">
      <DialogTitle>Ocultar {ocultar?.nombre}</DialogTitle>
      <DialogContent>
        <Typography mb={2}>Elige dónde mover los leads de esta columna. La etapa dejará de aparecer en los gráficos y análisis por etapa; su historial se conservará. Al restaurarla, los leads seguirán en la etapa de destino.</Typography>
        <TextField select label="Mover leads a" size="small" fullWidth value={destino} onChange={e => setDestino(e.target.value)}>
          {etapas.filter(e => e.activa && e.id !== ocultar?.id).map(e => <MenuItem key={e.id} value={e.id}>{e.nombre}</MenuItem>)}
        </TextField>
      </DialogContent>
      <DialogActions><Button onClick={() => setOcultar(null)}>Cancelar</Button><Button disabled={!destino} onClick={() => { guardar(ocultar.id, { activa: false }, { [ocultar.id]: destino }); setOcultar(null); }}>Mover y ocultar</Button></DialogActions>
    </Dialog>
  </Stack>;
}
